import { number, object, string } from 'yup'

import { i18nErrorCodes } from '../form-utils'

const { required, min1, max256 } = i18nErrorCodes

export default object().shape({
  name:  string().required(required),
  grade: string().required(required),
  hours: number().min(1, min1).max(256, max256),
})

export const emptyCoachingCertificate = {
  name:  '',
  grade: '',
  hours: 0,
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/coaching-certificate.schema.ts